export const addTypeAndParentSlugToTopics = (obj, parentSlug) => {
  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      obj[key].type = 'topic';
      obj[key].parentSlug = parentSlug;
    }
  }
};
